<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="12">
            <a-form-item label="测评类">
              <j-input v-model="queryParam.category" ></j-input>
            </a-form-item>
          </a-col>
            <a-col :span="12">
                <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                  <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
                  <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
                  <a-button @click="handleAdd" type="primary" icon="plus" style="margin-left: 8px">新增</a-button>
                </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <projectResultConfig-modal ref="modalForm" @ok="modalFormOk"></projectResultConfig-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import ProjectResultConfigModal from './modules/ProjectResultConfigModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: "ProjectResultConfigList",
    mixins:[JeecgListMixin],
    components: {
      JInput,
      ProjectResultConfigModal
    },
    data () {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        description: '表单结果逻辑配置管理页面',
        // 表头
        columns: [
          {
            title: '测评类',
            align:"center",
            dataIndex: 'category'
          },
          {
            title: '名称',
            align:"center",
            dataIndex: 'name'
          },
		   {
            title: '排序',
            align:"center",
            dataIndex: 'sortNum'
           },
		   {
            title: '计算配置',
            align:"center",
         ellipsis: true, //表格省略
         dataIndex: 'configJson'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/project/projectResultConfig/list",
          delete: "/project/projectResultConfig/delete",
       },
        isorter:{
          column: 'sortNum',
          order: 'asc',
        },
        disableMixinCreated:true,
    }
  },
  computed: {
  },
    mounted(){
      this.baseQueryParam = {projectId:this.projectId}
      this.loadData()
    },
    methods: {
      loadDataCallback(){
        this.$emit('loadDataChange',this.dataSource)
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>